/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2022-2023 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import { ValidationObserver } from "vee-validate";
import en from "vee-validate/dist/locale/en.json";
import it from "vee-validate/dist/locale/it.json";
import { ValidationMessageTemplate, ValidationRuleFunction } from "vee-validate/dist/types/types";
import { Vue } from "vue-property-decorator";

export type VeeValidateForm = Vue & {
    validate: ({silent}?: { silent?: boolean }) => Promise<boolean>
    reset: () => void
}

export type VeeValidateRefs = {
    observer: InstanceType<typeof ValidationObserver>
}

export const domain: ValidationRuleFunction = (value: string): boolean => {
    if (!value) {
        return true
    }

    return /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(value)
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
en.messages["domain"] = "The {_field_} field must be a valid domain in the format «domain.tld» or «sub.domain.tld»"
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
it.messages["domain"] = "Il campo {_field_} deve essere un dominio valido nel formato «dominio.tld» o «sub.dominio.tld»"

export const VeeTranslations = {
    en,
    it,
} as Record<string, {
    name?: string;
    messages?: Record<string, ValidationMessageTemplate>;
    names?: Record<string, string>;
    fields?: Record<string, Record<string, ValidationMessageTemplate>>;
}>
